var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.7731 5.13542c.3087.22751.3746.66225.1471.97101l-9.7222 13.19447c-.1121.1521-.2814.252-.4687.2766-.1874.0246-.3766-.0283-.5242-.1463l-6.94445-5.5556c-.29948-.2395-.34804-.6766-.10845-.976.23959-.2995.6766-.3481.97609-.1085l6.38021 5.1042 9.2936-12.61275c.2275-.30877.6622-.37464.971-.14713z",
    fill: "#17a680"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCheck);
export default __webpack_public_path__ + "static/media/ico_check.f018daeb0a328bf97b36f6f58a1fda28.svg";
export { ForwardRef as ReactComponent };